import { debug } from './logger'

export const isEmail = (email) => {
  const pattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
  return pattern.test(email)
}

export const isPostalCode = (code) => {
  const pattern = /^[0-9]{5}?$/
  return code && code.match(pattern)
}

/*
 * Zip codes stored on professionals are free text: they may carry surrounding
 * spaces, duplicates or invalid values. Keep only clean, unique 5-digit codes.
 */
export const sanitizeZipCodes = (zipCodes) => {
  return (zipCodes || [])
    .map((code) => (code || '').toString().trim())
    .filter((code) => isPostalCode(code))
    .filter((code, index, all) => all.indexOf(code) === index)
}

export const isCityName = (cityName) => {
 // CORRECTION: Accept figures for arrondissements
  const pattern = /^[- '0-9A-Za-zÀ-ÿœŒæÆ]+$/
  return cityName && cityName.match(pattern)
}

export const isSponsorCode = (code) => {
  // Pattern for sponsor code: 2 letters + 2 digits (example: "ab12")
  const pattern = /^[a-z]{2}[0-9]{2}$/
  return code && code.match(pattern)
}

export const isNotEmpty = (value) => {
  return value && value !== ''
}

export const isPhone = (value) => {
  const pattern = /^[0-9 .]+$/
  return pattern.test(value)
}

export const isInteger = (value) => {
  const pattern = /^[0-9]+$/
  return pattern.test(value)
}

export const isFloat = (value) => {
  const pattern = /^[\d.]+$/
  return pattern.test(value)
}

export const isBic = (bic) => {
  const pattern = /^[a-zA-Z]{6}[0-9a-zA-Z]{2}([0-9a-zA-Z]{3})?$/
  return pattern.test(bic)
}

export const isIban = (iban) => {
  const pattern = /^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?)/
  return pattern.test(iban)
}

export const isLength = (ismin, expected, value) => {
  return (ismin) ? value.length > expected : value.length < expected
}

export const isStriclyEqual = (expected, value) => {
  return expected === value
}

/*
 * Test the type of the input file
 * @param expected : The expectation check
 * @param value: The value of the field to check
 */
export const isType = (expected, value) => {
  switch (expected) {
    case 'numeric':
      return isInteger(value)
    case 'city':
      return isCityName(value)
    case 'zipcode':
      return isPostalCode(value)
    case 'email':
      return isEmail(value)
    case 'bic':
      return isBic(value)
    case 'iban':
      return isIban(value)
    default:
      debug(`[utilities][validators.isType] Unknown type ${expected}`)
  }
}

export function validateReferences (refs) {
  let isValid = true
  let errors = []
  for (let ref in refs) {
    let stateRef = refs[ref].state
    if (!stateRef.validating) {
      if (refs[ref].handleValidation) {
        stateRef = refs[ref].handleValidation()
      } else {
        debug(`[utilities][validators.validateReferences] No 'handleValidation' function for ${refs[ref].props ? refs[ref].props.name || refs[ref].props.label : '[no name or label on component]'}`)
      }
    }
    if (stateRef && !stateRef.isValid) {
      isValid = false
    }
    if (stateRef && !stateRef.isValid && stateRef.label) {
      errors.push(`${stateRef.label}`)
    }
  }
  return { isValid, errors }
}

export const validateRule = (rule, value) => {
  switch (rule.type) {
    case 'required':
      return isNotEmpty(value)
    case 'type':
      return isType(rule.expected, value)
    case 'minLength':
      return isLength(true, rule.expected, value) || (rule.required === false && !value)
    case 'maxLength':
      return isLength(false, rule.expected, value)
    default:
      debug(`[utilities][validators.validateInputsRule] Unknown rule.type ${rule.type}`)
  }
}

export function validateRules (rules, value) {
  const errors = []
  for (let rule of rules) {
    let isValid = validateRule(rule, value)
    if (!isValid) {
      errors.push(rule)
    }
  }
  return { isValid: !errors.length, errors }
}



// WEBPACK FOOTER //
// ./src/utilities/validators.js